import { fetchHelper } from '@price-point/http-helpers';
import _ from 'lodash';

export default async function hasValidToken(token) {
  if (!token) {
    return false;
  }

  try {
    const response = await fetchHelper(token, 'GET', '/me');
    return Boolean(_.get(response, 'id'));
  } catch (ex) {
    return false;
  }
}
